import { IParametroModel } from "../interfaces/parametros/IParametroModel";

export class ParametroModel implements IParametroModel {
    idParametroDetalle: number;
    idParametroMaestro: number;
    nombre: string;
    valor: string;

    constructor(){
        this.idParametroDetalle = 0;
        this.idParametroMaestro = 0;
        this.nombre = '';
        this.valor = '';
    }
}